(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Products_listing_slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('.ourBoxPrdctColm___swp');
    const metaContainer = document.getElementById('dynamicMetaContent');

    if (!sliderEl) return;

    /* =========================================
     SWIPER INIT
  ========================================= */
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      watchSlidesProgress: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.ourBoxPrdctColm___swp .swiper-button-next',
        prevEl: '.ourBoxPrdctColm___swp .swiper-button-prev',
      },
      pagination: {
        el: '.ourBoxPrdctColm___swp .swiper-pagination',
        clickable: true,
        bulletClass: 'ourBoxDot',
        bulletActiveClass: 'ourBoxDot--active',
      },
      on: {
        init: function () {
          setTimeout(() => {
            activateInitialState();
          }, 50);

          updateMeta(this);
          syncSticky(this);
          updateSavings(this, 'onqc');
        },
        slideChange: function () {
          updateMeta(this);
          syncSticky(this);
          updateSavings(this, 'onqc');
        },
      },
    });
    /* =========================================
     MANUAL ACTIVE FIX (END SAFE)
  ========================================= */
    sliderEl.addEventListener('click', function (e) {
      const slide = e.target.closest('.ourBoxPrdctItem');
      if (!slide) return;
      // Remove Swiper active classes
      swiper.slides.forEach((s) => {
        s.classList.remove('swiper-slide-active', 'swiper-slide-prev', 'swiper-slide-next');
      });
      // Force clicked slide active
      slide.classList.add('swiper-slide-active');
      const index = [...swiper.slides].indexOf(slide);
      if (swiper.slides[index - 1]) swiper.slides[index - 1].classList.add('swiper-slide-prev');
      if (swiper.slides[index + 1]) swiper.slides[index + 1].classList.add('swiper-slide-next');
      // 🔥 Update everything manually
      updateMetaBySlide(slide);
      updateStickyBySlide(slide);
      updateSavingsBySlide(slide, 'onqc');
    });
    /* =========================================
     META (SWIPER BASED)
  ========================================= */
    function updateMeta(swiperInstance) {
      if (!metaContainer) return;
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateMetaBySlide(activeSlide);
    }
    function updateMetaBySlide(slide) {
      const hiddenMeta = slide.querySelector('.product-meta-content');
      if (!hiddenMeta || !metaContainer) return;
      metaContainer.innerHTML = hiddenMeta.innerHTML;
      const tabs = metaContainer.querySelectorAll('.tab-btn');
      if (tabs.length) {
        tabs[0].classList.add('active');
      }
      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          tabs.forEach((t) => t.classList.remove('active'));
          this.classList.add('active');
          updateSavingsBySlide(slide, this.dataset.tab);
        });
      });
    }

    /* =========================================
   FORCE FIRST TAB + FIRST PRODUCT ACTIVE
========================================= */
    function activateInitialState() {
      const stickyWrapper = document.querySelector('.singleSelectTabsWrapper');
      if (!stickyWrapper) return;

      const firstTabBtn = stickyWrapper.querySelector('.tabBtn');
      const firstTabContent = stickyWrapper.querySelector('.tabContent');
      const firstVariant = stickyWrapper.querySelector('.tabContent .variantCard');

      if (!firstTabBtn || !firstTabContent || !firstVariant) return;

      /* Reset everything */
      stickyWrapper.querySelectorAll('.tabBtn').forEach((b) => b.classList.remove('active'));
      stickyWrapper.querySelectorAll('.tabContent').forEach((c) => c.classList.remove('active'));
      stickyWrapper.querySelectorAll('.variantCard').forEach((v) => v.classList.remove('active'));

      /* Activate first tab + product */
      firstTabBtn.classList.add('active');
      firstTabContent.classList.add('active');
      firstVariant.classList.add('active');

      const variantId = firstVariant.dataset.variantId;
      if (!variantId) return;

      const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');

      if (!slide) return;

      const index = [...swiper.slides].indexOf(slide);

      if (index >= 0) {
        swiper.slideTo(index, 0, false);
      }
    }
    /* =========================================
     SAVINGS
  ========================================= */
    function updateSavings(swiperInstance, region) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateSavingsBySlide(activeSlide, region);
    }
    function updateSavingsBySlide(slide, region) {
      const hiddenComparison = slide.querySelector('.comparion-table');
      if (!hiddenComparison) return;
      const sourceTbody = hiddenComparison.querySelector('#' + region + 'comparision tbody');
      const bottomTableBody = document.querySelector('#bottomSavingsTable tbody');
      if (!sourceTbody || !bottomTableBody) return;
      bottomTableBody.innerHTML = sourceTbody.innerHTML;
    }
    /* =========================================
     STICKY SYNC (SWIPER BASED)
  ========================================= */
    function syncSticky(swiperInstance) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateStickyBySlide(activeSlide);
    }
    function updateStickyBySlide(slide) {
      const variantId = slide.dataset.variantId;
      if (!variantId) return;
      const allCards = document.querySelectorAll('.variantCard');
      let matchedCard = null;
      allCards.forEach((card) => {
        if (card.dataset.variantId === variantId) {
          matchedCard = card;
        }
      });
      if (!matchedCard) return;
      const wrapper = matchedCard.closest('.singleSelectTabsWrapper');
      if (!wrapper) return;
      wrapper.querySelectorAll('.variantCard').forEach((c) => c.classList.remove('active'));
      wrapper.querySelectorAll('.tabContent').forEach((t) => t.classList.remove('active'));
      wrapper.querySelectorAll('.tabBtn').forEach((b) => b.classList.remove('active'));
      matchedCard.classList.add('active');
      const tabContent = matchedCard.closest('.tabContent');
      if (!tabContent) return;
      tabContent.classList.add('active');
      const correctBtn = wrapper.querySelector('.tabBtn[data-tab="' + tabContent.id + '"]');
      if (correctBtn) correctBtn.classList.add('active');
    }
    /* =========================================
     STICKY SECTION CLICK LOGIC
  ========================================= */
    const stickyWrapper = document.querySelector('.singleSelectTabsWrapper');
    if (stickyWrapper) {
      stickyWrapper.addEventListener('click', function (e) {
        const tabBtn = e.target.closest('.tabBtn');
        // if (tabBtn) {
        //   const allBtns = stickyWrapper.querySelectorAll('.tabBtn');
        //   const allContents = stickyWrapper.querySelectorAll('.tabContent');
        //   allBtns.forEach((btn) => btn.classList.remove('active'));
        //   allContents.forEach((content) => content.classList.remove('active'));
        //   tabBtn.classList.add('active');
        //   const target = stickyWrapper.querySelector('#' + tabBtn.dataset.tab);
        //   if (target) target.classList.add('active');
        //   return;
        // }

        if (tabBtn) {
          const allBtns = stickyWrapper.querySelectorAll('.tabBtn');
          const allContents = stickyWrapper.querySelectorAll('.tabContent');

          allBtns.forEach((btn) => btn.classList.remove('active'));
          allContents.forEach((content) => content.classList.remove('active'));

          tabBtn.classList.add('active');

          const target = stickyWrapper.querySelector('#' + tabBtn.dataset.tab);
          if (!target) return;

          target.classList.add('active');

          /* 🔥 Activate FIRST PRODUCT inside this tab */
          const firstVariant = target.querySelector('.variantCard');
          if (!firstVariant) return;

          target.querySelectorAll('.variantCard').forEach((v) => v.classList.remove('active'));
          firstVariant.classList.add('active');

          /* 🔥 Move Swiper to this product */
          const variantId = firstVariant.dataset.variantId;

          const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');

          if (!slide) return;

          const index = [...swiper.slides].indexOf(slide);

          if (index >= 0) {
            swiper.slideTo(index);
          }

          return;
        }
        const variantCard = e.target.closest('.variantCard');
        if (variantCard) {
          const variantId = variantCard.dataset.variantId;
          const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');
          if (slide) {
            const index = [...swiper.slides].indexOf(slide);
            if (index >= 0) swiper.slideTo(index);
          }
          return;
        }
        const addBtn = e.target.closest('.mainAddToCart');
        if (addBtn) {
          const tabContent = addBtn.closest('.tabContent');
          if (!tabContent) return;
          let selected = tabContent.querySelector('.variantCard.active');
          if (!selected) selected = tabContent.querySelector('.variantCard');
          if (!selected) return;
          const variantId = selected.dataset.variantId;
          const sellingPlanId = selected.dataset.sellingPlanId;
          const item = {
            id: Number(variantId),
            quantity: 1,
          };
          if (sellingPlanId) {
            item.selling_plan = Number(sellingPlanId);
          }
          addBtn.classList.add('loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] }),
          })
            .then(() => {
              window.location.href = '/cart';
            })
            .catch((err) => {
              console.error('Cart error:', err);
              alert('Product unavailable');
            })
            .finally(() => {
              addBtn.classList.remove('loading');
            });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Products_listing_slider_only"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('.ourBoxPrdctColm___swp');
    const metaContainer = document.getElementById('dynamicMetaContent');

    if (!sliderEl) return;

    /* =========================================
     SWIPER INIT
  ========================================= */
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      watchSlidesProgress: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.ourBoxPrdctColm___swp .swiper-button-next',
        prevEl: '.ourBoxPrdctColm___swp .swiper-button-prev',
      },
      pagination: {
        el: '.ourBoxPrdctColm___swp .swiper-pagination',
        clickable: true,
        bulletClass: 'ourBoxDot',
        bulletActiveClass: 'ourBoxDot--active',
      },
      on: {
        init: function () {
          setTimeout(() => {
            activateInitialState();
          }, 50);

          updateMeta(this);
          syncSticky(this);
          updateSavings(this, 'onqc');
        },
        slideChange: function () {
          updateMeta(this);
          syncSticky(this);
          updateSavings(this, 'onqc');
        },
      },
    });
    /* =========================================
     MANUAL ACTIVE FIX (END SAFE)
  ========================================= */
    sliderEl.addEventListener('click', function (e) {
      const slide = e.target.closest('.ourBoxPrdctItem');
      if (!slide) return;
      // Remove Swiper active classes
      swiper.slides.forEach((s) => {
        s.classList.remove('swiper-slide-active', 'swiper-slide-prev', 'swiper-slide-next');
      });
      // Force clicked slide active
      slide.classList.add('swiper-slide-active');
      const index = [...swiper.slides].indexOf(slide);
      if (swiper.slides[index - 1]) swiper.slides[index - 1].classList.add('swiper-slide-prev');
      if (swiper.slides[index + 1]) swiper.slides[index + 1].classList.add('swiper-slide-next');
      // 🔥 Update everything manually
      updateMetaBySlide(slide);
      updateStickyBySlide(slide);
      updateSavingsBySlide(slide, 'onqc');
    });
    /* =========================================
     META (SWIPER BASED)
  ========================================= */
    function updateMeta(swiperInstance) {
      if (!metaContainer) return;
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateMetaBySlide(activeSlide);
    }
    function updateMetaBySlide(slide) {
      const hiddenMeta = slide.querySelector('.product-meta-content');
      if (!hiddenMeta || !metaContainer) return;
      metaContainer.innerHTML = hiddenMeta.innerHTML;
      const tabs = metaContainer.querySelectorAll('.tab-btn');
      if (tabs.length) {
        tabs[0].classList.add('active');
      }
      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          tabs.forEach((t) => t.classList.remove('active'));
          this.classList.add('active');
          updateSavingsBySlide(slide, this.dataset.tab);
        });
      });
    }

    /* =========================================
   FORCE FIRST TAB + FIRST PRODUCT ACTIVE
========================================= */
    function activateInitialState() {
      const stickyWrapper = document.querySelector('.singleSelectTabsWrapper');
      if (!stickyWrapper) return;

      const firstTabBtn = stickyWrapper.querySelector('.tabBtn');
      const firstTabContent = stickyWrapper.querySelector('.tabContent');
      const firstVariant = stickyWrapper.querySelector('.tabContent .variantCard');

      if (!firstTabBtn || !firstTabContent || !firstVariant) return;

      /* Reset everything */
      stickyWrapper.querySelectorAll('.tabBtn').forEach((b) => b.classList.remove('active'));
      stickyWrapper.querySelectorAll('.tabContent').forEach((c) => c.classList.remove('active'));
      stickyWrapper.querySelectorAll('.variantCard').forEach((v) => v.classList.remove('active'));

      /* Activate first tab + product */
      firstTabBtn.classList.add('active');
      firstTabContent.classList.add('active');
      firstVariant.classList.add('active');

      const variantId = firstVariant.dataset.variantId;
      if (!variantId) return;

      const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');

      if (!slide) return;

      const index = [...swiper.slides].indexOf(slide);

      if (index >= 0) {
        swiper.slideTo(index, 0, false);
      }
    }
    /* =========================================
     SAVINGS
  ========================================= */
    function updateSavings(swiperInstance, region) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateSavingsBySlide(activeSlide, region);
    }
    function updateSavingsBySlide(slide, region) {
      const hiddenComparison = slide.querySelector('.comparion-table');
      if (!hiddenComparison) return;
      const sourceTbody = hiddenComparison.querySelector('#' + region + 'comparision tbody');
      const bottomTableBody = document.querySelector('#bottomSavingsTable tbody');
      if (!sourceTbody || !bottomTableBody) return;
      bottomTableBody.innerHTML = sourceTbody.innerHTML;
    }
    /* =========================================
     STICKY SYNC (SWIPER BASED)
  ========================================= */
    function syncSticky(swiperInstance) {
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      if (!activeSlide) return;
      updateStickyBySlide(activeSlide);
    }
    function updateStickyBySlide(slide) {
      const variantId = slide.dataset.variantId;
      if (!variantId) return;
      const allCards = document.querySelectorAll('.variantCard');
      let matchedCard = null;
      allCards.forEach((card) => {
        if (card.dataset.variantId === variantId) {
          matchedCard = card;
        }
      });
      if (!matchedCard) return;
      const wrapper = matchedCard.closest('.singleSelectTabsWrapper');
      if (!wrapper) return;
      wrapper.querySelectorAll('.variantCard').forEach((c) => c.classList.remove('active'));
      wrapper.querySelectorAll('.tabContent').forEach((t) => t.classList.remove('active'));
      wrapper.querySelectorAll('.tabBtn').forEach((b) => b.classList.remove('active'));
      matchedCard.classList.add('active');
      const tabContent = matchedCard.closest('.tabContent');
      if (!tabContent) return;
      tabContent.classList.add('active');
      const correctBtn = wrapper.querySelector('.tabBtn[data-tab="' + tabContent.id + '"]');
      if (correctBtn) correctBtn.classList.add('active');
    }
    /* =========================================
     STICKY SECTION CLICK LOGIC
  ========================================= */
    const stickyWrapper = document.querySelector('.singleSelectTabsWrapper');
    if (stickyWrapper) {
      stickyWrapper.addEventListener('click', function (e) {
        const tabBtn = e.target.closest('.tabBtn');
        // if (tabBtn) {
        //   const allBtns = stickyWrapper.querySelectorAll('.tabBtn');
        //   const allContents = stickyWrapper.querySelectorAll('.tabContent');
        //   allBtns.forEach((btn) => btn.classList.remove('active'));
        //   allContents.forEach((content) => content.classList.remove('active'));
        //   tabBtn.classList.add('active');
        //   const target = stickyWrapper.querySelector('#' + tabBtn.dataset.tab);
        //   if (target) target.classList.add('active');
        //   return;
        // }

        if (tabBtn) {
          const allBtns = stickyWrapper.querySelectorAll('.tabBtn');
          const allContents = stickyWrapper.querySelectorAll('.tabContent');

          allBtns.forEach((btn) => btn.classList.remove('active'));
          allContents.forEach((content) => content.classList.remove('active'));

          tabBtn.classList.add('active');

          const target = stickyWrapper.querySelector('#' + tabBtn.dataset.tab);
          if (!target) return;

          target.classList.add('active');

          /* 🔥 Activate FIRST PRODUCT inside this tab */
          const firstVariant = target.querySelector('.variantCard');
          if (!firstVariant) return;

          target.querySelectorAll('.variantCard').forEach((v) => v.classList.remove('active'));
          firstVariant.classList.add('active');

          /* 🔥 Move Swiper to this product */
          const variantId = firstVariant.dataset.variantId;

          const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');

          if (!slide) return;

          const index = [...swiper.slides].indexOf(slide);

          if (index >= 0) {
            swiper.slideTo(index);
          }

          return;
        }
        const variantCard = e.target.closest('.variantCard');
        if (variantCard) {
          const variantId = variantCard.dataset.variantId;
          const slide = document.querySelector('.ourBoxPrdctItem[data-variant-id="' + variantId + '"]');
          if (slide) {
            const index = [...swiper.slides].indexOf(slide);
            if (index >= 0) swiper.slideTo(index);
          }
          return;
        }
        const addBtn = e.target.closest('.mainAddToCart');
        if (addBtn) {
          const tabContent = addBtn.closest('.tabContent');
          if (!tabContent) return;
          let selected = tabContent.querySelector('.variantCard.active');
          if (!selected) selected = tabContent.querySelector('.variantCard');
          if (!selected) return;
          const variantId = selected.dataset.variantId;
          const sellingPlanId = selected.dataset.sellingPlanId;
          const item = {
            id: Number(variantId),
            quantity: 1,
          };
          if (sellingPlanId) {
            item.selling_plan = Number(sellingPlanId);
          }
          addBtn.classList.add('loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] }),
          })
            .then(() => {
              window.location.href = '/cart';
            })
            .catch((err) => {
              console.error('Cart error:', err);
              alert('Product unavailable');
            })
            .finally(() => {
              addBtn.classList.remove('loading');
            });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunch-process-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.hwOddBnchWrksClmn__swp').length > 0) {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let swiperElementCardSwp = document.querySelector('.hwOddBnchWrksClmn__swp.swiper');
      if (swiperElementCardSwp) {
        let config = {
          spaceBetween: 5,
          allowTouchMove: !0,
          slidesPerView: 'auto',
          grabCursor: !0,
          keyboard: { enabled: !0 },
          pagination: { el: '.hwOddBnchWrksClmn__swp .swiper-pagination', clickable: true },
          breakpoints: { 750: { spaceBetween: 30 } },
        };
        isIOS || ((config.freeMode = !0), (config.mousewheel = { forceToAxis: !0, thresholdDelta: 35 }));
        window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.realCstmrVdClmn__swp').length > 0) {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let swiperElementCardSwp = document.querySelector('.realCstmrVdClmn__swp.swiper');
      if (swiperElementCardSwp) {
        let config = {
          spaceBetween: 16,
          allowTouchMove: !0,
          slidesPerView: 'auto',
          grabCursor: !0,
          keyboard: { enabled: !0 },
        };
        isIOS || ((config.freeMode = !0), (config.mousewheel = { forceToAxis: !0, thresholdDelta: 35 }));
        window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
      }
    }
  });
  document.addEventListener('shopify:section:load', () => {
    if (document.querySelectorAll('.realCstmrVdClmn__swp').length > 0) {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let swiperElementCardSwp = document.querySelector('.realCstmrVdClmn__swp.swiper');
      if (swiperElementCardSwp) {
        let config = {
          spaceBetween: 16,
          allowTouchMove: !0,
          slidesPerView: 'auto',
          grabCursor: !0,
          keyboard: { enabled: !0 },
        };
        isIOS || ((config.freeMode = !0), (config.mousewheel = { forceToAxis: !0, thresholdDelta: 35 }));
        window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-with-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.yourBoxAccInCnt').forEach((el) => {
      el.addEventListener('click', (target) => {
        target.preventDefault();
        target.target.closest('.yourBoxAccItemCnt').classList.toggle('active');
        if (target.target.closest('.yourBoxAccItemCnt').classList.contains('active')) {
          let HeightElementData = target.target.closest('.yourBoxAccItemCnt').querySelector('.yourBoxAccPanel');
          target.target
            .closest('.yourBoxAccItemCnt')
            .querySelector('.yourBoxAccPanel').style.maxHeight = `${HeightElementData.scrollHeight}px`;
        } else {
          target.target.closest('.yourBoxAccItemCnt').querySelector('.yourBoxAccPanel').style.maxHeight = null;
        }
      });
    });
  });

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.yourBoxAccInCnt').forEach((el) => {
      el.addEventListener('click', (target) => {
        target.preventDefault();
        target.target.closest('.yourBoxAccItemCnt').classList.toggle('active');
        if (target.target.closest('.yourBoxAccItemCnt').classList.contains('active')) {
          let HeightElementData = target.target.closest('.yourBoxAccItemCnt').querySelector('.yourBoxAccPanel');
          target.target
            .closest('.yourBoxAccItemCnt')
            .querySelector('.yourBoxAccPanel').style.maxHeight = `${HeightElementData.scrollHeight}px`;
        } else {
          target.target.closest('.yourBoxAccItemCnt').querySelector('.yourBoxAccPanel').style.maxHeight = null;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  function initFaqAccordion() {
    document.querySelectorAll('.SegFaqAccInCnt').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        const item = e.target.closest('.SegFaqAccItem');
        const panel = item.querySelector('.SegFaqPanel');

        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
          panel.style.maxHeight = null;
        }
      });
    });

    // ✅ Open first FAQ by default
    const firstItem = document.querySelector('.SegFaqAccItem.active');
    if (firstItem) {
      const panel = firstItem.querySelector('.SegFaqPanel');
      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', initFaqAccordion);
  document.addEventListener('shopify:section:load', initFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_productlisting"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', ()=>{
        document.querySelectorAll('.SegFaqAccInCnt').forEach((el)=>{
            el.addEventListener('click', (target)=>{
                target.preventDefault();
                target.target.closest('.SegFaqAccItem').classList.toggle('active');
                if ( target.target.closest('.SegFaqAccItem').classList.contains('active') ){
                    let HeightElementData = target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel');
                    target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel').style.maxHeight = `${HeightElementData.scrollHeight}px`;
                }else{
                    target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel').style.maxHeight = null;
                }             
            })
        })
    })

    document.addEventListener("shopify:section:load", () => {
        document.querySelectorAll('.SegFaqAccInCnt').forEach((el)=>{
            el.addEventListener('click', (target)=>{
                target.preventDefault();
                target.target.closest('.SegFaqAccItem').classList.toggle('active');
                if ( target.target.closest('.SegFaqAccItem').classList.contains('active') ){
                    let HeightElementData = target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel');
                    target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel').style.maxHeight = `${HeightElementData.scrollHeight}px`;
                }else{
                    target.target.closest('.SegFaqAccItem').querySelector('.SegFaqPanel').style.maxHeight = null;
                }             
            })
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{

   document?.querySelectorAll(`.giveaway___form__html__email_term_txt`)?.forEach((el)=>{
      el?.querySelector('a')?.addEventListener('click', (tg)=>{
        if( tg?.currentTarget?.getAttribute('href')?.includes('#terms') ){
          tg.preventDefault();
          if( !document?.querySelector(`.yourBoxAccItemCnt`).classList.contains('active') ){
            document?.querySelector(`.yourBoxAccInCnt`)?.click();
          }
          setTimeout(() => {
            document?.querySelector('[data-section-type="faq-with-icons"]')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }, 150)
        }
      })
    })

    class giveawayEnterance extends HTMLElement {
      constructor() {
        super();
        this.querySelectorAll(`[js-validation-check]`).forEach((el)=>{el.addEventListener('change', this.debugGiveawayEnterance.bind(this)) });
        this.querySelector('[js-giveaway-register]').addEventListener('click', this.giveawayRegisteration.bind(this));
      }
      debugGiveawayEnterance(target){
        if( target.target.getAttribute('name') == 'giveawayEmail' ){
          this.Email = target.target.value;
          this.Email = this.Email.trim();
          this.Email = this.Email.toLowerCase();
          this.email$CodeRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
          if ( this.Email.length === 0  ){
            target.target.classList.remove('notvalid','empty_error');
          }else if (!this.email$CodeRegex.test(this.Email)) {
            target.target.classList.add('notvalid');
          }else{
            target.target.classList.remove('notvalid','empty_error');
          }  
        }
      }
      async giveawayRegisteration(event){
        const button = event.currentTarget;
        button.closest('.giveaway___form__html__nt').querySelectorAll('[name="giveawayEmail"]').forEach((el)=>{el.classList.remove('notvalid','empty_error'); el.dispatchEvent(new Event('change'));});
        this.AllCorrections = [];
        button.closest('.giveaway___form__html__nt').querySelectorAll('[name="giveawayEmail"]').forEach((el)=>{
          this.emptyCheck = el.value.trim();
          if(this.emptyCheck == ''){
            el.classList.add('empty_error');
          }else if( el.classList.contains('notvalid') ){
            el.classList.add('empty_error');
          }else{
            this.AllCorrections.push('true')
          }
        })

        button.closest('.giveaway___form__html__nt').querySelectorAll('[type="checkbox"]').forEach((el)=>{
          if(!el.checked){
            el.classList.add('empty_error');
          }else{
            el.classList.remove('empty_error');
            this.AllCorrections.push('true')
          }
        })      

        const totalRequired = 1 + button.closest('.giveaway___form__html__nt').querySelectorAll('[type="checkbox"]').length;
          if( this.AllCorrections.length == totalRequired ){
          this.targetEl = button;
          this.targetEl.disabled = true;
          this.targetEl.querySelector('span').classList.add('hidden');
          this.targetEl.querySelector('.loading-overlay__spinner').classList.remove('hidden');
          this.AcceptEmail = button.closest('.giveaway___form__html__nt').querySelector('[name="giveawayEmail"]')?.value?.trim() || ''; 

          this.payload = {
              data: {
                  type: 'subscription',
                  attributes: {
                      profile: {
                          data: {
                              type: 'profile',
                              attributes: {
                                  properties: {
                                      'SMS Consent': 'FALSE'
                                  },
                                  email: this.AcceptEmail
                              }
                          }
                      }
                  },
                  relationships: {
                      list: {
                          data: {
                              type: 'list',
                              id: 'V894x6'
                          }
                      }
                  }
              }
          };
          try {
            this.response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=S4fun6', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'REVISION': '2024-07-15'
              },
              body: JSON.stringify(this.payload)
            });
            if (!this.response.ok) {
              throw new Error(`Request failed. Status: ${this.response.status}`);
            }
            this.responseText = await this.response.text();

            // Hide the form, show the success message
            button.closest('giveaway-email').querySelector('.giveaway___form__html__nt').classList.add('hidden');
            button.closest('giveaway-email').querySelector('[js-success-message]').classList.remove('hidden');         
            if (this.responseText) { 
              try {
                const json = JSON.parse(this.responseText);
              } catch (err) {
                console.error('Invalid JSON response:', err);
              }
            } else {
              console.warn('Response was empty');
            }
          } catch (error) {
            console.error('Submission error:', error);
            this.targetEl.disabled = false;
            this.targetEl.querySelector('span').classList.remove('hidden');
            this.targetEl.querySelector('.loading-overlay__spinner').classList.add('hidden');           
          }

        }
      }
    }
    customElements.define('giveaway-email', giveawayEnterance);

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-customers-pdplisting"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  initHappyCustomerSwiper();
});

document.addEventListener('shopify:section:load', function () {
  initHappyCustomerSwiper();
});

function initHappyCustomerSwiper() {
  if (document.querySelectorAll('.hpCstmrReviewBoxClmnMn').length === 0) return;

  let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  let swiperElementCardSwp = document.querySelector('.hpCstmrReviewBoxClmnMn.swiper');

  if (!swiperElementCardSwp) return;

  // Destroy previous instance (important for Shopify editor)
  if (window.cardsSwiperInstance) {
    window.cardsSwiperInstance.destroy(true, true);
  }

  let config = {
    spaceBetween: 16,
    allowTouchMove: true,
    slidesPerView: 1,
    grabCursor: true,
    keyboard: { enabled: true },

    pagination: {
      el: swiperElementCardSwp.querySelector('.swiper-pagination'),
      clickable: true,
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  };

  // Keep your freeMode logic for non-iOS
  if (!isIOS) {
    config.freeMode = true;
    config.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
  }

  window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-customers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelectorAll('.hpCstmrReviewBoxClmnMn').length > 0) {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let swiperElementCardSwp = document.querySelector('.hpCstmrReviewBoxClmnMn.swiper');
      if (swiperElementCardSwp) {
        let config = {
          spaceBetween: 8,
          allowTouchMove: !0,
          slidesPerView: 'auto',
          grabCursor: !0,
          keyboard: { enabled: !0 },
        };
        isIOS || ((config.freeMode = !0), (config.mousewheel = { forceToAxis: !0, thresholdDelta: 35 }));
        window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
      }
    }
  });
  document.addEventListener('shopify:section:load', () => {
    if (document.querySelectorAll('.hpCstmrReviewBoxClmnMn').length > 0) {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      let swiperElementCardSwp = document.querySelector('.hpCstmrReviewBoxClmnMn.swiper');
      if (swiperElementCardSwp) {
        let config = {
          spaceBetween: 8,
          allowTouchMove: !0,
          slidesPerView: 'auto',
          grabCursor: !0,
          keyboard: { enabled: !0 },
        };
        isIOS || ((config.freeMode = !0), (config.mousewheel = { forceToAxis: !0, thresholdDelta: 35 }));
        window.cardsSwiperInstance = new Swiper(swiperElementCardSwp, config);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.mb_labguage_identity').forEach((el)=>{
      el.addEventListener('click', (target)=>{
        target.preventDefault();
        target.target.closest('.no-js-hidden').querySelector('[name="locale_code"]').value = target.target.dataset.languageIso;
        target.target.closest('.no-js-hidden').querySelector('[type="submit"]').click();
      })
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    document?.querySelector(`[js-see-more-pantry]`)?.addEventListener('click', (el)=>{
      el?.preventDefault();
      el?.target?.closest('.recipes___itm__main__ingredients_box_items')?.querySelector('.youNeed__box_within__action')?.classList?.toggle('active');
      if( !el.target.closest('.recipes___itm__main__ingredients_box_items').querySelector('.youNeed__box_within__action').classList.contains('active') ){
          el.target.closest('.recipes___itm__main__ingredients_box_items').querySelector('.youNeed__box_within__action').innerHTML = `See more...`;
          el.target.closest('.recipes___itm__main__ingredients_box_items').querySelectorAll('.recipes___itm__main__ingredients_box_item.moreEl').forEach((tg)=>{tg.classList.add('hidden')});
      }else{
          el.target.closest('.recipes___itm__main__ingredients_box_items').querySelector('.youNeed__box_within__action').innerHTML = `See less...`;
          el.target.closest('.recipes___itm__main__ingredients_box_items').querySelectorAll('.recipes___itm__main__ingredients_box_item').forEach((tg)=>{tg.classList.remove('hidden')});
      }
    })

    document?.querySelectorAll('.recipes___itm__main__instructions_header')?.forEach((el)=>{
      el?.addEventListener('click', (target)=>{
          target.preventDefault();
          target.target.closest('.recipes___itm__main__instructions').classList.toggle('active');
          if ( target.target.closest('.recipes___itm__main__instructions').classList.contains('active') ){
              let HeightElementData = target.target.closest('.recipes___itm__main__instructions').querySelector('.recipes___itm__main__instructions_box');
              target.target.closest('.recipes___itm__main__instructions').querySelector('.recipes___itm__main__instructions_box').style.maxHeight = `${HeightElementData.scrollHeight}px`;
          }else{
              target.target.closest('.recipes___itm__main__instructions').querySelector('.recipes___itm__main__instructions_box').style.maxHeight = null;
          }             
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pdp"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-variation"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{

    function TimerTill__giveaway() {
        const targetDate = new Date("2026-04-28T12:00:00-07:00").getTime();
        const now = new Date().getTime();
        const distance = targetDate - now;
        if (distance < 0) {
            document.querySelector(".giveaway__times__toover").classList.remove('hidden');
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const format = (num) => String(num).padStart(2, '0').split('');

        const d = format(days);
        const h = format(hours);
        const m = format(minutes);
        const s = format(seconds);

        document.getElementById("days-tens").innerText = d[0];
        document.getElementById("days-ones").innerText = d[1];
        document.getElementById("hours-tens").innerText = h[0];
        document.getElementById("hours-ones").innerText = h[1];
        document.getElementById("mins-tens").innerText = m[0];
        document.getElementById("mins-ones").innerText = m[1];
        document.getElementById("secs-tens").innerText = s[0];
        document.getElementById("secs-ones").innerText = s[1];
    }

    setInterval(TimerTill__giveaway, 1000);
    TimerTill__giveaway();

    class giveawayEnteranceBanner extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll(`[js-validation-check-entrance]`).forEach((el)=>{el.addEventListener('change', this.debugGiveawayEnterance.bind(this)) });
        this.querySelector('[js-giveaway-entrance-register]').addEventListener('click', this.giveawayRegisteration.bind(this));
    }
    debugGiveawayEnterance(target){
 if( target.target.getAttribute('name') == 'giveawayEntranceEmail' ){
    this.Email = target.target.value;
    this.Email = this.Email.trim();
    this.Email = this.Email.toLowerCase();
    this.email$CodeRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if ( this.Email.length === 0  ){
    target.target.classList.remove('notvalid','empty_error');
    }else if (!this.email$CodeRegex.test(this.Email)) {
    target.target.classList.add('notvalid');
    }else{
    target.target.classList.remove('notvalid','empty_error');
    }  
}
    }
    async giveawayRegisteration(event){
    const button = event.currentTarget;
    button.closest('.giveaway___form__entrance__wp_xt').querySelectorAll('[name="giveawayEntranceEmail"]').forEach((el)=>{el.classList.remove('notvalid','empty_error'); el.dispatchEvent(new Event('change'));});
    this.AllCorrections = [];
    button.closest('.giveaway___form__entrance__wp_xt').querySelectorAll('[name="giveawayEntranceEmail"]').forEach((el)=>{
        this.emptyCheck = el.value.trim();
        if(this.emptyCheck == ''){
        el.classList.add('empty_error');
        }else if( el.classList.contains('notvalid') ){
        el.classList.add('empty_error');
        }else{
        this.AllCorrections.push('true')
        }
    })

    button.closest('.giveaway___form__entrance__wp_xt').querySelectorAll('[type="checkbox"]').forEach((el)=>{
        if(!el.checked){
        el.classList.add('empty_error');
        }else{
        el.classList.remove('empty_error');
        this.AllCorrections.push('true')
        }
    })      

    const totalRequired = 1 + button.closest('.giveaway___form__entrance__wp_xt').querySelectorAll('[type="checkbox"]').length;
    if( this.AllCorrections.length == totalRequired ){
        this.targetEl = button;
        this.targetEl.disabled = true;
        this.targetEl.querySelector('span').classList.add('hidden');
        this.targetEl.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        this.AcceptEmail = button.closest('.giveaway___form__entrance__wp_xt').querySelector('[name="giveawayEntranceEmail"]')?.value?.trim() || '';

        this.payload = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                properties: {
                                    'SMS Consent': 'FALSE'
                                },
                                email: this.AcceptEmail
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: 'V894x6'
                        }
                    }
                }
            }
        };
        try {
        this.response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=S4fun6', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'REVISION': '2024-07-15'
            },
            body: JSON.stringify(this.payload)
        });
        if (!this.response.ok) {
            throw new Error(`Request failed. Status: ${this.response.status}`);
        }
        this.responseText = await this.response.text();

        // Hide the form, show the success message
        button.closest('email-entrance').querySelector('.giveaway___form__entrance').classList.add('hidden');
        button.closest('email-entrance').querySelector('[js-success-message]').classList.remove('hidden');

        if (this.responseText) { 
            try {
            const json = JSON.parse(this.responseText);
            } catch (err) {
            console.error('Invalid JSON response:', err);
            }
        } else {
            console.warn('Response was empty');
        }
        } catch (error) {
        console.error('Submission error:', error);
        this.targetEl.disabled = false;
        this.targetEl.querySelector('span').classList.remove('hidden');
        this.targetEl.querySelector('.loading-overlay__spinner').classList.add('hidden');           
        }

    }
    }
}
customElements.define('email-entrance', giveawayEnteranceBanner);

  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-pantry-deck"] && !Shopify.designMode) return;
  try {
    
    (function () {

        const PDF_FILES = [
            {
                url: 'https://cdn.shopify.com/s/files/1/2218/5947/files/OB_Pantry_Vendor_Deck_2026.pdf?v=1779699252',
                filename: 'OB_Pantry_Vendor_Deck_2026.pdf'
            },
            {
                url: 'https://cdn.shopify.com/s/files/1/2218/5947/files/OB_Pantry_2-pager.pdf?v=1779699251',
                filename: 'OB_Pantry_2-pager.pdf'
            }
        ];

        function setLinkText(link, text) {
            const textNode = [...link.childNodes].find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            if (textNode) {
                textNode.textContent = text;
            } else {
                link.insertAdjacentText('beforeend', text);
            }
        }

        function triggerBlobDownload(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a   = document.createElement('a');
            a.href     = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(() => URL.revokeObjectURL(url), 10000);
        }        
        
        async function fetchAndDownload({ url, filename }) {
            const res = await fetch(url, { mode: 'cors' });
            if (!res.ok) throw new Error(`HTTP ${res.status} — ${url}`);
            const blob = await res.blob();
            triggerBlobDownload(blob, filename);
        }

        async function downloadAllPdfs(link) {
            if (link._downloading) return;
            link._downloading = true;
            const textNode    = [...link.childNodes].find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            const originalText = textNode ? textNode.textContent : link.textContent;
            setLinkText(link, 'Downloading…');
            const results = [];
            for (let i = 0; i < PDF_FILES.length; i++) {
                try {
                    await fetchAndDownload(PDF_FILES[i]);
                    results.push('ok');
                } catch (err) {
                    window.open(PDF_FILES[i].url, '_blank', 'noopener,noreferrer');
                    results.push('fallback');
                }
                if (i < PDF_FILES.length - 1) {
                    await new Promise(r => setTimeout(r, 700));
                }
            }

            const allOk = results.every(r => r === 'ok');
            setLinkText(link, allOk ? 'Downloaded' : 'Check Downloads');
            setTimeout(() => {
                setLinkText(link, originalText);
                link._downloading = false;
            }, 2000);
        }

        // document.querySelector('.pn_download_material_btn')?.addEventListener('click', function (e) {
        //     e.preventDefault();
        //     downloadAllPdfs(this);
        // });

        function isPdfUrl(url) {
            try {
                const path = new URL(url).pathname;
                return path.toLowerCase().endsWith('.pdf');
            } catch (_) {
                return url.toLowerCase().includes('.pdf');
            }
        }

        function getFilename(link) {
            if (link.dataset.filename) return link.dataset.filename;
            try {
                const path = new URL(link.href).pathname;
                const name = path.split('/').pop();
                return decodeURIComponent(name) || 'download.pdf';
            } catch (_) {
                return 'download.pdf';
            }
        }

        async function downloadPdf(link) {
            if (link._downloading) return;
            link._downloading = true;
            const textNode = [...link.childNodes].find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
            const originalText = textNode ? textNode.textContent : link.textContent;
            setLinkText(link, ' Downloading…');
            const url      = link.href;
            const filename = getFilename(link);

            try {
                const res = await fetch(url, { mode: 'cors' });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const blob = await res.blob();
                triggerBlobDownload(blob, filename);

                setLinkText(link, ' Downloaded');
                setTimeout(() => {
                    setLinkText(link, originalText);
                    link._downloading = false;
                }, 2000);

            } catch (err) {
                window.open(url, '_blank', 'noopener,noreferrer');
                setLinkText(link, originalText);
                link._downloading = false;
            }
        }

        document.addEventListener('click', function (e) {
            const link = e.target.closest('a');
            if (!link) return;
            const isTagged = link.hasAttribute('data-pdf-download');
            const isPdf    = isPdfUrl(link.href);
            if (!isTagged && !isPdf) return;
            e.preventDefault();
            downloadPdf(link);
        });

        document.querySelectorAll(`[data-pdf-popup]`).forEach((pdf)=>{
            pdf.addEventListener(`click`, (tg)=>{
                tg.preventDefault();
                document.body.classList.add('suggestion__popup');
            })
        })

        document.querySelectorAll(`.pantry__confirmation__popup__overlay`).forEach((pdf)=>{
            pdf.addEventListener(`click`, (tg)=>{
                tg.preventDefault();
                document.body.classList.remove('suggestion__popup');
            })
        })        

    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-zip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll(`[js-submit-form]`).forEach((el)=>{
        el.addEventListener('click', (target)=>{
            target.preventDefault();
            let target$button = target.target;
            let postal$input = target$button.closest(`.postalcode__enterance__interior`).querySelector('.postalcode__enterance__groups').querySelector(`.postalcode__enterance_input`);
            let postal$code = postal$input.value.toUpperCase();
            if (!postal$code) return;

            target$button.classList.add('loading');
            fetch(`https://client.codevibez.com/oddbunch/index.php?zipcode=${postal$code}`)
            .then(response => response.json())
            .then(data => {
                if(data.success){
                    document.querySelector('.forpostal__success').querySelector('.postalcode__resultZip').textContent = data.zipcode || zipcode;
                    document.querySelector('.forpostal__success').querySelector(".postalcode__enterance_msg_msg").textContent = JSON.stringify(data.value) || "Service available.";
                    document.querySelectorAll('.postalcode__enterance_msg').forEach((el)=>{el.classList.add('hidden')});
                    document.querySelector('.forpostal__success').classList.remove('hidden');
                }else{
                    document.querySelector('.forpostal__error').querySelector(".postalcode__enterance_msg_msg").textContent = data.value;
                    document.querySelectorAll('.postalcode__enterance_msg').forEach((el)=>{el.classList.add('hidden')});
                    document.querySelector('.forpostal__error').classList.remove('hidden');
                }
            })
            .catch(err => {
                document.querySelector('.forpostal__error').querySelector(".postalcode__enterance_msg_msg").textContent =
                    "Failed to connect to the server. Please try again.";
                document.querySelectorAll('.postalcode__enterance_msg').forEach((el)=>{el.classList.add('hidden')});
                document.querySelector('.forpostal__error').classList.remove('hidden');                    
            })
            .finally(() => {
                target$button.classList.remove('loading');
            });

        });
    });

    document.querySelectorAll(`.postalcode__enterance_input`).forEach((el) => {
        el.addEventListener('input', (event) => {
            document.querySelectorAll('.postalcode__enterance_msg').forEach((el)=>{el.classList.add('hidden')});
            let input$Element = event.target;
            let value = input$Element.value.toUpperCase();
            if (value.length > 6) value = value.slice(0, 6);
            let result = "";
            const patterns = ["letter", "digit", "letter", "digit", "letter", "digit"];
            for (let i = 0; i < value.length; i++) {
                let char = value[i];
                if (patterns[i] === "letter" && /[A-Z]/.test(char)) {
                    result += char;
                } else if (patterns[i] === "digit" && /[0-9]/.test(char)) {
                    result += char;
                }else{
                    document.querySelector('.forpostal__error').querySelector(".postalcode__enterance_msg_msg").textContent =
                        "We're unable to find that postcode, please re-check";
                    document.querySelectorAll('.postalcode__enterance_msg').forEach((el)=>{el.classList.add('hidden')});
                    document.querySelector('.forpostal__error').classList.remove('hidden');
                }
            }
            input$Element.value = result;
        });
    });
  
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-buybox"]) return;
  try {
    
    document.addEventListener("DOMContentLoaded",()=>{
        document?.querySelector(`.buybox__whats_insidebox_content_header_tabs`)?.querySelectorAll(`[data-box]`)?.forEach((tb)=>{
            tb.addEventListener('click', (tg)=>{
                tg.preventDefault();
                let boxIndex = tg.currentTarget.dataset.box;
                document?.querySelector(`.buybox__whats_insidebox_content_header_tabs`).querySelectorAll(`[data-box]`).forEach((tb)=>{tb.classList.remove('active')});
                document?.querySelector(`.buybox__whats_insidebox_content_brief_nt`).querySelectorAll(`[data-content-box]`).forEach((tb)=>{tb.classList.add('hidden')});
                tg.currentTarget.classList.add('active');
                document?.querySelector(`.buybox__whats_insidebox_content_brief_nt`).querySelector(`[data-content-box="${boxIndex}"]`).classList.remove('hidden');
            })
        })       
        document?.querySelectorAll('.pdp-buybox__whats_insidebox_header')?.forEach((el)=>{
            el?.addEventListener('click', (target)=>{
                target.preventDefault();
                target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector('.pdp-buybox__whats_insidebox_content')?.classList?.toggle('active');
                if( target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector('.pdp-buybox__whats_insidebox_content').classList.contains('active') ){
                    target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector(`.pdp-buybox__whats_insidebox_icons`).querySelector(`.whats_insidebox_icons_plus_icon`).classList.add('hidden');
                    target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector(`.pdp-buybox__whats_insidebox_icons`).querySelector(`.whats_insidebox_icons_minus_icon`).classList.remove('hidden');
                }else{
                    target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector(`.pdp-buybox__whats_insidebox_icons`).querySelector(`.whats_insidebox_icons_plus_icon`).classList.remove('hidden');
                    target?.target?.closest('.pdp-buybox__whats_insidebox_nt')?.querySelector(`.pdp-buybox__whats_insidebox_icons`).querySelector(`.whats_insidebox_icons_minus_icon`).classList.add('hidden');
                }
            })
        })         
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('.ourBoxPrdctColm___swp.swiper');
    if (!sliderEl) return;

    const swiper = new Swiper(sliderEl, {
      spaceBetween: 5,
      centeredSlides: false,
      slidesPerView: 'auto',
      initialSlide: 2, // <-- starts from the third slide

      navigation: {
        nextEl: '.ourBoxPrdctColm___swp .swiper-button-next',
        prevEl: '.ourBoxPrdctColm___swp .swiper-button-prev',
      },

      pagination: {
        el: '.ourBoxPrdctColm___swp .swiper-pagination',
        clickable: true,
        bulletClass: 'ourBoxDot',
        bulletActiveClass: 'ourBoxDot--active',
      },

      breakpoints: {
        750: {
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', ()=>{
        document.querySelectorAll('.faqAccQue').forEach((el)=>{
            el.addEventListener('click', (target)=>{
                target.preventDefault();
                target.target.closest('.faqMnAccItem').classList.toggle('active');
                if ( target.target.closest('.faqMnAccItem').classList.contains('active') ){
                    let HeightElementData = target.target.closest('.faqMnAccItem').querySelector('.faqPanel');
                    target.target.closest('.faqMnAccItem').querySelector('.faqPanel').style.maxHeight = `${HeightElementData.scrollHeight}px`;
                }else{
                    target.target.closest('.faqMnAccItem').querySelector('.faqPanel').style.maxHeight = null;
                }             
            })
        })

        document.querySelectorAll('.faq_content__actionvw_more span').forEach((el)=>{
            el.addEventListener('click', (target)=>{
                target.preventDefault();
                target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').classList.toggle('active');
                if( target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').classList.contains('active') ){
                    if( target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').classList.contains('envw') ){
                        target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').querySelector('span').innerHTML = `see less`;
                    }else{
                        target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').querySelector('span').innerHTML = `voir moins`;
                    }
                    target.target.closest('.faqMnCnt').querySelector('.faqAccMn').querySelectorAll('.faqMnAccItem.vw_more').forEach((tb)=>{ tb.classList.remove('hidden') })
                }else{
                    if( target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').classList.contains('envw') ){
                        target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').querySelector('span').innerHTML = `see more`;
                    }else{
                        target.target.closest('.faqMnCnt').querySelector('.faq_content__actionvw_more').querySelector('span').innerHTML = `voir plus`;                      
                    }
                    target.target.closest('.faqMnCnt').querySelector('.faqAccMn').querySelectorAll('.faqMnAccItem.vw_more').forEach((tb)=>{ tb.classList.add('hidden') })
                    setTimeout(() => {
                        var targetElement = document.querySelector('.faqSecMn');
                        window.scrollTo({
                            top: targetElement.offsetTop - document.querySelector('#shopify-section-header').clientHeight,
                            behavior: 'smooth'
                        });                    
                    }, 200);                     
                }
            });
        })

        setInterval(() => {
            if( document.querySelectorAll('.yotpo-rewards-history').length > 0 ){
                document.querySelector('.yotpo-rewards-history').querySelector('.yotpo-grid').querySelectorAll('.yotpo-grid-row').forEach((el)=>{
                    let dateCheckUpdated = el.querySelector('.yotpo-inner-text').innerHTML;
                    if( dateCheckUpdated.indexOf('2025') > -1){
                        el.closest('.yotpo-grid-row').classList.add('hidden');
                    }
                })
            }
        }, 50);        
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok_video_section"] && !Shopify.designMode) return;
  try {
    
function initCustomerSwiper(section = document) {
  let swiperElement = section.querySelector(".realCstmrVdClmn__swp.swiper");
  if (!swiperElement) return;

  // Destroy if already initialized
  if (swiperElement.classList.contains("swiper-initialized")) {
    swiperElement.swiper.destroy(true, true);
  }

let config = {
  spaceBetween: 16,
  grabCursor: true,

breakpoints: {
  0: {
    slidesPerView: 1.1,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: {
      el: swiperElement.querySelector(".swiper-pagination"),
      clickable: true
    }
  },
  768: {
    slidesPerView: 4,
    spaceBetween: 16,
    allowTouchMove: false,
    pagination: false
  }
}

};


  new Swiper(swiperElement, config);
}

// Page load
document.addEventListener("DOMContentLoaded", function() {
  initCustomerSwiper(document);
});

// Shopify editor reload
document.addEventListener("shopify:section:load", function(e) {
  initCustomerSwiper(e.target);
});

  } catch(e) { console.error(e); }
})();
})();
